'use client';

import React from 'react';
import styled from 'styled-components';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import Link from 'next/link';

export default function TermsOfServicePage() {
  return (
    <>
      <Header handleClickIndex={() => {}} />
      <div className="header-gap-creator"></div>
      <Breadcrumbs items={[{ label: 'Terms of Service' }]} />

      <main className="container-0">
        <ContentWrapper>
          <div>
            <h1 className="faqs-links">Terms of Service</h1>
            <p>
              Thanks for using greenfilter.com and the services of Green Filter USA
              ("Services"). The Services are provided by Green Filter USA,
              Pennsylvania, United States. You can reach us at{' '}
              <a href="tel:+17244302050">(724) 430-2050</a> or{' '}
              <a href="mailto:csr@greenfilter.com">csr@greenfilter.com</a>.
              <br />
              <br />
              By using our Services, you are agreeing to these terms. Please read
              them carefully.
            </p>

            <h4 className="faqs-links">Using our Services</h4>
            <p>
              You must follow any policies made available to you within the
              Services.
              <br />
              <br />
              Using our Services does not give you ownership of any intellectual
              property right in our Services or the content you access. You may
              not use content from our Services unless you obtain permission from
              its owner and or are otherwise permitted by law. These terms do not
              grant you the right to use any branding or logos used in our
              Services. Don't remove, obscure, or alter any legal notices
              displayed in or along with our Services.
              <br />
              <br />
              Our Services display some content that is not Green Filter USA&apos;s.
              This content is the sole responsibility of the entity
              that makes it available. We may review content to determine whether
              it is illegal or violates our policies, and we may remove or refuse
              to display content that we reasonably believe violates our policies
              or the law. But that does not necessarily mean that we review
              content, so please don't assume that we do.
              <br />
              <br />
              In connection with your use of the Services, we may send you service
              announcements, administration messages and other information. You
              may opt out of some of those communications.
            </p>

            <h4 className="faqs-links">Your Content in our Services</h4>
            <p>
              Some of our Services allow you to upload, submit, store, send or
              receive content. You retain ownership of any intellectual property
              rights that you hold in that content. In short, what belongs to you
              stays yours.
              <br />
              <br />
              When you upload, submit, store, send or receive content to or
              through our Services, you give Green Filter USA (and those we
              work with) a worldwide license to use, host, store, reproduce,
              modify, create derivative works (such as those resulting from
              translations, adaptations or other changes we make so that your
              content works better with our Services), communicate, publish,
              publicly perform, publicly display and distribute such content. The
              rights you grant in this license are for the limited purpose of
              operating, promoting, and improving our Services, and to develop new
              ones.
            </p>

            <h4 className="faqs-links">Privacy Policy</h4>
            <p>
              Green Filter USA respects your privacy and promises to earn and
              keep your trust. We understand the importance of privacy, and we
              want you to be as comfortable as possible visiting our website and
              using its Services. All information about you is securely stored and
              will not be used in ways that you have not consented. We will not
              disclose, sell or distribute any information that identifies you to
              a third party without your explicitly approval, except to the extent
              necessary to comply with applicable law, legal process or in a legal
              proceedings where such information is relevant.
              <br />
              <br />
              For more information, see our{' '}
              <Link href="/privacy-policy">Privacy Policy</Link> or visit our{' '}
              <Link href="/contact-us">contact page</Link>.
            </p>
          </div>
        </ContentWrapper>
      </main>

      <Footer />
    </>
  );
}

const ContentWrapper = styled.div`
  padding: 75px 20px 50px;

  .title-header {
    font-size: 32px;
    font-weight: bold;
  }

  .faqs-links {
    font-size: 20px;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 20px;
  }

  ul {
    font-size: 16px;
  }

  a {
    color: #14800d;
    font-size: 16px;
  }

  h4 {
    padding-bottom: 10px;
    color: #333;
    font-weight: normal !important;
    line-height: 1em;
    text-align: left;
    font-family: 'Arial';
    font-size: 18px;
  }

  p {
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    font-family: 'Arial', Helvetica, Arial, Lucida, sans-serif;
  }

  h2 {
    font-family: Lato, sans-serif;
    font-size: 30px !important;
  }
`;
